import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtTimeAgo } from "@/lib/labels";

const ACTOR_CLASS = { user: "b-muted", system: "b-wait", ai: "b-prod", platform: "b-sla" };
const ACTOR_LABEL = {
  user: "member", system: "automatic", ai: "AI",
  // Worth naming plainly. A client should be able to see when we acted inside
  // their workspace, not have it look like one of their own people did.
  platform: "Prioris staff",
};

/** What has happened in this workspace, newest first. */
export default function SettingsAudit() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/audit?limit=200").then((r) => setData(r.data)).catch(() => setData(false));
  }, []);

  if (data === null) return <div className="text-[13px]" style={{ color: "var(--text-muted)" }}>Loading audit…</div>;
  if (data === false) return <div className="text-[13px]" style={{ color: "var(--text-muted)" }}>Could not load the audit trail.</div>;

  return (
    <div>
      <p className="text-[12.5px] mb-4" style={{ color: "var(--text-secondary)" }}
         data-testid="audit-retention">
        {/* Said out loud so a short history reads as a plan boundary rather
            than a quiet month. Nothing is deleted — this is what you can see. */}
        {data.retention_days
          ? `Your ${data.plan_code} plan shows the last ${data.retention_days} days.`
          : "Full history."}
      </p>

      <div className="card overflow-x-auto" data-testid="audit-table">
        <table className="w-full min-w-[640px] text-[13px]">
          <thead>
            <tr className="text-left" style={{ color: "var(--text-muted)", borderBottom: "1px solid var(--border)" }}>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">When</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Who</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">What</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">On</th>
            </tr>
          </thead>
          <tbody>
            {(data.events || []).length === 0 && (
              <tr><td colSpan={4} className="py-10 text-center" style={{ color: "var(--text-muted)" }}>
                Nothing recorded yet.
              </td></tr>
            )}
            {(data.events || []).map((e) => (
              <tr key={e.id} style={{ borderBottom: "1px solid var(--border)" }}
                  data-testid={`audit-${e.id}`}>
                <td className="py-2.5 px-3 font-mono text-[11.5px]">{fmtTimeAgo(e.at)}</td>
                <td className="py-2.5 px-3">
                  <span className={`badge ${ACTOR_CLASS[e.actor_type] || "b-muted"}`}>
                    {ACTOR_LABEL[e.actor_type] || e.actor_type}
                  </span>
                </td>
                <td className="py-2.5 px-3 font-mono text-[12px]">{e.action_type}</td>
                <td className="py-2.5 px-3" style={{ color: "var(--text-secondary)" }}>
                  {e.target_type}
                  {e.metadata?.name && <span className="ml-1">{e.metadata.name}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
